import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { NationBuilderTokenProvider } from "./common/contexts/NationBuilderTokenProvider";
import { AuthProvider } from "./common/contexts/AuthProvider";
import { ResearchTaskProvider } from "./common/contexts/ResearchTaskProvider";
import { CircleTaskProvider } from "./common/contexts/CircleTaskProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <NationBuilderTokenProvider>
          <ResearchTaskProvider>
            <CircleTaskProvider>
              <App />
            </CircleTaskProvider>
          </ResearchTaskProvider>
        </NationBuilderTokenProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
